var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useToggle } from '../../../hooks/useToggle';
import { LinkAndCTAElement } from './LinkAndCTAElement';
// import { LeftSection } from '../LeftSection';
import './LinkAndCTA.scss';
export var LinkAndCTA = function (_a) {
    var template = _a.template, ctaCopy = _a.ctaCopy, classNameModifier = _a.classNameModifier, title = _a.title, description = _a.description, ctaText = _a.ctaText, ctaLink = _a.ctaLink, itemsDataList = _a.itemsDataList, additionalCTA = _a.additionalCTA, offeringsHeading = _a.offeringsHeading, 
    // offeringsHeadingUrl,
    offeringsDescription = _a.offeringsDescription, additionalResources = _a.additionalResources, isExternal = _a.isExternal, isHovered = _a.isHovered, setIsHovered = _a.setIsHovered;
    // Custom Hooks
    var _b = useToggle(), isDropdownOpen = _b[0], _c = _b[1], openDropdown = _c.on, closeDropdown = _c.off, toggleDropdown = _c.toggle;
    var _d = useState(false), click = _d[0], setClick = _d[1];
    var handleClick = function () { return setClick(!click); };
    var handleButtonWithKeyboard = function (_a) {
        var key = _a.key;
        if (isDropdownOpen && key === 'Escape')
            closeDropdown();
        if (!isDropdownOpen && key === 'ArrowDown')
            openDropdown();
    };
    var handleListWithKeyboard = function (_a) {
        var key = _a.key;
        if (key === 'Escape')
            closeDropdown();
    };
    var myTimeout;
    var myInterval;
    var handleMouseOff = function () {
        myTimeout = setTimeout(function () {
            closeDropdown();
            setIsHovered(false);
        }, 300);
    };
    var handleMouseOver = function () {
        clearTimeout(myTimeout);
        if (!isHovered) {
            openDropdown();
            setIsHovered(true);
        }
    };
    var mouseMovement = function (e) {
        if (!isHovered) {
            // setTimeout(() => {
            openDropdown();
            // }, 300);
        }
    };
    return (_jsxs("div", __assign({ onMouseEnter: handleMouseOver, onMouseLeave: handleMouseOff, onMouseMove: mouseMovement }, { children: [_jsx("div", { className: "safeBar2" }, void 0),
            _jsx("button", __assign({ className: "nav__links nav__links--" + classNameModifier + " nav__links--hover", type: "button", "data-bs-toggle": "dropdown", "aria-expanded": isDropdownOpen ? 'true' : 'false', onClick: toggleDropdown, onKeyDown: handleButtonWithKeyboard, onFocus: openDropdown }, { children: ctaCopy }), void 0),
            isDropdownOpen && (_jsx("div", __assign({ className: "navbar_dropdown-menu-" + classNameModifier + " " + (click ? 'navbar__dropdown-menu clicked' : 'navbar__dropdown-menu'), "aria-labelledby": classNameModifier + "LinkAndCTAButton", onClick: handleClick, onKeyDown: handleListWithKeyboard }, { children: _jsx("div", { children: _jsx(LinkAndCTAElement, { template: template, title: title, description: description, ctaText: ctaText, ctaLink: ctaLink, items: itemsDataList, offeringsHeading: offeringsHeading, 
                        // offeringsHeadingUrl={offeringsHeadingUrl}
                        offeringsDescription: offeringsDescription, additionalResources: additionalResources, additionalCTA: additionalCTA, isExternal: isExternal }, void 0) }, void 0) }), void 0))] }), void 0));
};
